// extracted by mini-css-extract-plugin
export default {"legend":"Legend_legend__IUAh2","is-horizontal":"Legend_is-horizontal__C7rzv","legend-item":"Legend_legend-item__5cEAO"};